/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Maxfeature11Inputs */

const zh_plan_maxfeature11 = /** @type {(inputs: Plan_Maxfeature11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含 Pro 全部功能`)
};

const en_plan_maxfeature11 = /** @type {(inputs: Plan_Maxfeature11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything in Pro`)
};

const es_plan_maxfeature11 = /** @type {(inputs: Plan_Maxfeature11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo en Pro`)
};

/**
* | output |
* | --- |
* | "Everything in Pro" |
*
* @param {Plan_Maxfeature11Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_maxfeature11 = /** @type {((inputs?: Plan_Maxfeature11Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Maxfeature11Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_maxfeature11(inputs)
	if (locale === "en") return en_plan_maxfeature11(inputs)
	return es_plan_maxfeature11(inputs)
});
export { plan_maxfeature11 as "plan_maxFeature1" }